import { connect } from 'react-redux';

import { TextWithLink } from './TextWithLink';
import { isLeadFactory } from '../../../../utils/agent';
import { openFeedbackPopup } from '../../../actions/feedback';

import type { DispatchReduxAction, IState } from '../../../../store';

export function mapStateToProps(state: IState) {
  return {
    isLeadFactory: isLeadFactory(state.offerData.offer),
    showWarningMessage: state.offerData.offer.showWarningMessage,
  };
}

export function mapDispatchToProps(dispatch: DispatchReduxAction) {
  return {
    onClick() {
      dispatch(openFeedbackPopup());
    },
  };
}

export const TextWithLinkContainer = connect(mapStateToProps, mapDispatchToProps)(TextWithLink);
